import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from "../../../assets/icons/logo.svg";
import HeaderMeta from "./meta/Header.meta";
import HeaderNav from "./nav/Header.nav";

import { observer } from '@legendapp/state/react';
import { useState } from "react";
import { state$ } from '../../../state';
import "./header.scss";

export const Header = observer(() => {

  const isFullWidthState = state$.settings.isFullWidthState.get();
  const [isMenuOpened, setMenuState] = useState(false);

  return (
    <>
      <header role="banner" className="app-header">
        <div className={`animated-max-width ${!isFullWidthState ? 'container' : 'container-fluid app-header--full'}`}>
          <div className="row">
            <div className="col d-flex f-wrap">
              <Link to="/" className="app-logo d-flex">
                <Logo />
              </Link>

              <div className={`app-nav--fs`}>
                <HeaderNav isMenuVisible={isMenuOpened} requestToggleMenu={(state) => setMenuState(state)} />
              </div>

              <HeaderMeta isMenuVisible={isMenuOpened} requestToggleBurgerMenu={(state) => setMenuState(state)} />
            </div>
          </div>
        </div>
      </header>
    </>
  )
})
